import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Notice, Spinner } from "../../ui/index.js";
import { useCabinet } from "./context.js";

/** Страницы настроек салона только владельцу (сервер тоже проверяет); мастер по прямой ссылке видит пояснение. */
export function OwnerOnly({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const cab = useCabinet();
  if (cab.loading) return <Spinner />;
  if (!cab.isOwner) return <Notice>{t("common.ownerOnly")}</Notice>;
  return <>{children}</>;
}
